<div class="supervision-wrapper">
<div class="row-top">
	<div class="row-left1 pointer" (click)="goBack()">
		<img src="assets/img/push-pin-pin.png" class="img push-pin-pin" />
		<p class="text-b text-back-to-summary">Back to summary</p>
	</div>

	
</div>
<div class="supervision-layout">
<div class="col2">

	<div class="row1">
		<div class="row-left2">
			<div class="filter-chips-row" *ngIf="activeFilterChips.length">
				<span class="filter-chip" *ngFor="let chip of activeFilterChips">
					{{ chip.label }}
					<span class="filter-chip-remove" (click)="$event.stopPropagation(); removeFilter(chip.field)">&times;</span>
				</span>
			</div>

			<mat-form-field appearance="outline" class="dropdown-header">
				<mat-label>Year</mat-label>
				<mat-select [(ngModel)]="selectedyear" class="dropdown-label" (selectionChange)="getDataOnSelection()">
					<mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dropdown-header">
				<mat-label>Month</mat-label>
				<mat-select [(ngModel)]="selectedMonth" (selectionChange)="getDataOnSelection()">
					<mat-option *ngFor="let m of months" [value]="m.value">
						{{ m.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dropdown-header">
				<mat-label>Report Type</mat-label>
				<mat-select [(ngModel)]="selectedReportType" (selectionChange)="getDataOnSelection()">
					<mat-option *ngFor="let rpt of rptTypes" [value]="rpt.key">
						{{ rpt.value }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="row-right">
			<div class="rc-btn-secondary2 pointer" (click)="exportToExcel()">
				<object data="assets/img/rc-btn-secondary-icons8-excel.svg" class="rc-btn-secondary-icons8-excel"
					type="image/svg+xml"></object>
				<p class="text-c">Export to Excel</p>
			</div>
	    </div>
	</div>


	<div class="body-a">
		<div class="body-a-col2">
			<div class="table-scroll-region">
				<table mat-table [dataSource]="accountsDataSource">
					<tbody>
					<!-- Checkbox column (hidden for now)
					<ng-container matColumnDef="select">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let row">
							<mat-checkbox (click)="$event.stopPropagation()"
								(change)="$event ? selection.toggle(row) : null"
								[checked]="selection.isSelected(row)">
							</mat-checkbox>
						</td>
					</ng-container>
					-->

					<!-- Dynamic columns from visibleDisplayedColumns -->
					<ng-container *ngFor="let col of visibleDisplayedColumns" [matColumnDef]="col.field" [stickyEnd]="isLastColumn(col)">
						<th mat-header-cell *matHeaderCellDef [style.text-align]="getAlignment(col)">
							<span class="row-a header-with-filter">
								<span>{{col.headerName}}</span>
								<mat-icon class="filter-icon" [class.active-filter]="hasColumnFilter(col.field)"
									(click)="openColumnFilter($event, col)">keyboard_arrow_down</mat-icon>
							</span>
						</th>
						<td mat-cell *matCellDef="let row" 
						    [style.text-align]="getAlignment(col)"
							[style.white-space]="shouldWrap(col) ? 'normal' : 'nowrap'"
							[style.word-wrap]="shouldWrap(col) ? 'break-word' : null"
							[style.overflow-wrap]="shouldWrap(col) ? 'break-word' : null"
							[style.max-width]="shouldWrap(col) ? '200px' : null">
							<ng-container *ngIf="col.field === 'status'; else defaultCell">
								<div class="status-cell">
									<span class="status-dot" 
									[style.background-color]="getRowColor(row)"
									[style.border]="getRowColor(row) === '#F5F5F5' ? '1.5px solid #999' : 'none'"></span>
								<span class="status-text">{{row.status | titlecase}}</span>
							</div>
							<div *ngIf="isRowOpen(row)" class="alert-description">{{getRowAlertDescription(row).replace('Open ', '')}}</div>
							<div *ngIf="isRowDeferred(row) && getRowDeferredDate(row)" class="alert-description">{{getRowDeferredDate(row)}}</div>
							</ng-container>
							<ng-template #defaultCell>
								<div>{{formatValue(row[col.field], col)}}<span *ngIf="col.subField && isTimestamp(col)"> {{formatSubFieldValue(row[col.subField], col)}}</span></div>
								<div *ngIf="col.subField && !isTimestamp(col)" class="sub-field-text">{{row[col.subField]}}</div>
							</ng-template>
						</td>
					</ng-container>
					<!-- Actions -->
					<ng-container matColumnDef="actions" stickyEnd>
						<th mat-header-cell *matHeaderCellDef class="btn-light-top btn-light-top-label">&nbsp;</th>
						<td mat-cell *matCellDef="let row">
							<div class="actions-cell-wrap" style="position: relative; display: flex; align-items: center; justify-content: flex-end; width: 100%;">
								<div class="frame">
									<div class="frame-frame">
										<img src="assets/img/frame-more-vert.png" class="frame-more-vert"
											alt="More options" (click)="openCard(row)" style="cursor:pointer;" />
									</div>
									<button class="btn-primary hover-bright" (click)="openResponseDrawer(row, $event)">
										<p class="btn-primary-label">Respond</p>
										<img src="assets/img/btn-primary-icon.png" class="btn-primary-icon"
											alt="Respond" />
									</button>
								</div>
								<div *ngIf="openedCardRow === row" #activeActionBar class="action-bar pointer"
									style="position: absolute;"
									(click)="$event.stopPropagation(); openAccountActivity(row, $event)">
									Account Activity
								</div>
							</div>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumnNames;"></tr>
					</tbody>
				</table>
			</div>
			<div class="no-data-overlay" *ngIf="accountsDataSource.data.length === 0 && !isTableLoading">
				<div class="no-data-message">No Data Found.</div>
			</div>
		</div>

		<mat-paginator [pageSizeOptions]="[100, 200, 300]" showFirstLastButtons></mat-paginator>
	</div>
</div>

</div>
</div>